import React from 'react';
import useGenerateAnalysis from './useGenerateAnalysis';
import styles from './styles';
import { EmojiEvents } from '@mui/icons-material';
import { MarkdownReader } from '@/components/dataDisplay/MarkdownReader';
import Spinner from '@/components/dataDisplay/Spinner';

interface Props {
  emoji?: string;
  title: string;
  analysis?: string;
  contentInteractionId?: string;
  shouldGenerateAnalysis?: boolean;
}

const CoverWithAnalysis: React.FC<Props> = ({
  analysis,
  emoji,
  title,
  contentInteractionId,
  shouldGenerateAnalysis,
}) => {
  const { generatedAnalysis, loadingAnalysis } = useGenerateAnalysis({
    contentInteractionId,
    shouldGenerateAnalysis,
  });
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        {emoji ? <span style={styles.emoji}>{emoji}</span> : <EmojiEvents style={styles.emoji} />}
        <h1 style={styles.compactHeader}>
          <span style={styles.title}>¡Felicidades!</span>
          <span style={styles.subtitle}>Completaste: {title}</span>
        </h1>
      </div>
      <div style={styles.analysisContainer}>
        {analysis || (generatedAnalysis && !loadingAnalysis) ? (
          <MarkdownReader>{generatedAnalysis ?? analysis!}</MarkdownReader>
        ) : (
          <div style={styles.loadingContainer}>
            <Spinner width={35} />
            <p>Cargando Análisis</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CoverWithAnalysis;
